/*
 * parlay-cart-bridge.js
 * Bridges the ported Parlay commerce stack to Concept's native cart drawer.
 *
 * The Parlay snippets (parlay-buy-buttons, parlay-bundle, parlay-free-gifts-row,
 * parlay-quantity-breaks, parlay-upsell-block, ...) add to cart via /cart/add.js and
 * then (a) fetch `?sections=cart-drawer,cart-icon-bubble` and (b) hand-poke a Parlay
 * <cart-drawer> DOM (different markup + an open() method) that Concept doesn't have.
 *
 * Concept's <cart-drawer> instead refreshes + opens itself when it receives a
 * `cart:refresh` event with detail.open === true (see CartDrawer.onCartRefresh in
 * assets/cart.js). So this bridge works at the fetch layer, which is uniform across
 * every Parlay add path regardless of its bespoke post-add code:
 *
 *   1) On a successful POST to /cart/add.js, trigger Concept's `cart:refresh {open:true}`
 *      (refreshes the mini-cart and opens the drawer) and sync the header <cart-count>.
 *   2) Neutralise the legacy `?sections=cart-drawer|cart-icon-bubble` GETs by resolving
 *      them to empty JSON, so the Parlay snippets' bespoke drawer DOM-poking / open()
 *      calls are guarded out and can't throw or fight Concept's drawer. Concept uses
 *      `?section_id=` (singular), so its own section-render calls are untouched.
 */
(function () {
  var _fetch = window.fetch.bind(window);
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function urlOf(input) {
    if (typeof input === 'string') return input;
    if (input && input.url) return input.url;
    return '';
  }
  function methodOf(input, init) {
    if (init && init.method) return String(init.method).toUpperCase();
    if (input && input.method) return String(input.method).toUpperCase();
    return 'GET';
  }

  var timer = null;
  function refreshAndOpen() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      document.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })
      );
      _fetch(ROOT + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('cart-count').forEach(function (el) {
            el.textContent = cart.item_count;
            if (cart.item_count > 0) el.removeAttribute('hidden');
            else el.setAttribute('hidden', '');
          });
        })
        .catch(function () {});
    }, 60);
  }

  window.fetch = function (input, init) {
    var url = '';
    try { url = urlOf(input); } catch (e) {}

    // (2) Neutralise Parlay's legacy section-render GETs.
    if (/[?&]sections=cart-drawer/.test(url) || /[?&]sections=cart-icon-bubble/.test(url)) {
      return Promise.resolve(
        new Response('{}', { status: 200, headers: { 'Content-Type': 'application/json' } })
      );
    }

    var p = _fetch(input, init);

    // (1) After a successful add, drive Concept's native drawer.
    if (/\/cart\/add(\.js)?(\?|$)/.test(url) && methodOf(input, init) === 'POST') {
      p.then(function (res) {
        if (res && res.ok) refreshAndOpen();
      }).catch(function () {});
    }
    return p;
  };
})();
